export enum BookingState {
  Pending = 'Pending',
  Started = 'Started',
  Ended = 'Ended',
  Expired = 'Expired',
  // Invoiced = 'Invoiced',
  Cancelled = 'Cancelled',
}
